import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-btn-more',
  templateUrl: './btn-more.component.html',
  styleUrls: ['./btn-more.component.css']
})
export class BtnMoreComponent implements OnInit {

  @Input() btnMore_params: any = {}

  constructor() { }

  ngOnInit(): void {
  }

}
